import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import Sidebar from "../Sidebar";
import { UserProfileData } from "../../FetchAPI";
import ProfileEditValidation from "./ProfileEditValidation";
import { Link } from "react-router-dom";
import DeshBoardFooter from "../DeshBoardFooter";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { useAuth } from "../../../Store/AuthContext";
import "./profileEdit.css";
import { Helmet } from "react-helmet";
import VarifyEmailBtn from "./VarifyEmailBtn";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import NotifyMessage from "../../Others/NotifyMessage";
// import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function ProfileEdit() {
  const { userID, RendomTokenfetch } = useAuth();

  const location = useLocation();
  const returnTo = location.state?.returnTo || "/profile-edit"; // fallback to self

  const [ProfileuserData] = UserProfileData(RendomTokenfetch);
  // console.log(ProfileuserData);

  const navigate = useNavigate();

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);

  // Refs for all inputs
  const fnameRef = useRef(ProfileuserData?.firstname || "");
  const lnameRef = useRef(ProfileuserData?.lastname || "");
  // const emailRef = useRef(ProfileuserData?.email || "");
  // const numberRef = useRef(ProfileuserData?.number || "");

  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedcity, setSelectedcity] = useState("");

  const [selectCountry, setselectCountry] = useState("");
  const [pincode, setpincode] = useState("");

  const addressRef = useRef(ProfileuserData?.address || "");
  const profileImageRef = useRef();
  const bannerImageRef = useRef();
  const profileimagehiddenRef = useRef(ProfileuserData?.image || "");
  const bannerimagehiddenRef = useRef(ProfileuserData?.banner || "");

  useEffect(() => {
    if (ProfileuserData) {
      setSelectedState(ProfileuserData?.stateid || "");
      setSelectedcity(ProfileuserData?.cityid || "");
      setselectCountry(ProfileuserData?.countryid || "101"); // default to India
      setpincode(ProfileuserData?.pincode || "");
      setNumber(ProfileuserData?.number || "");
      setEmail(ProfileuserData?.email || "");
    }
  }, [ProfileuserData]);

  // Fetch States
  useEffect(() => {
    setLoading(true);
    const FetchSubServiceStateData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllState`, {
            params: { country_id: "101" },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setStates(response.data.allstateData || []);
              setCities([]);
            } else {
              setStates([]);
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchSubServiceStateData();
  }, [RendomTokenfetch]);

  // Fetch cities when state changes
  useEffect(() => {
    setLoading(true);
    const FetchServiceCityData = async () => {
      try {
        await axios
          .get(`${WebsiteAPIurl}getAllCity`, {
            params: { state_id: selectedState },
          })
          .then((response) => {
            if (response.data.Status === "1") {
              setCities(response.data.allcityData || []);
            }
            if (response.data.Status === "0") {
              setCities([]);
            }
          });
      } catch (err) {
        setError(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };
    FetchServiceCityData();
  }, [RendomTokenfetch, selectedState]);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handlepincode = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setpincode(value);
    }
  };

  // Handle On Form Submit
  const handleSubmit = (event) => {
    event.preventDefault();
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("firstname", fnameRef.current.value);
    fdata.append("lastname", lnameRef.current.value);
    fdata.append("email", email);
    fdata.append("country", selectCountry);
    fdata.append("pincode", pincode);
    fdata.append("city", selectedcity);
    fdata.append("state", selectedState);
    fdata.append("address", addressRef.current.value);
    fdata.append("oldimage", profileimagehiddenRef.current.value);
    fdata.append("oldbanner", bannerimagehiddenRef.current.value);

    // console.log(profileImageRef.current.files[0]);
    // console.log(bannerImageRef.current.files[0]);

    if (profileImageRef.current.files[0]) {
      fdata.append("image", profileImageRef.current.files[0]);
    }
    if (bannerImageRef.current.files[0]) {
      fdata.append("banner", bannerImageRef.current.files[0]);
    }

    axios
      .post(`${WebsiteAPIurl}userProfile_edit`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (
          fnameRef.current.value &&
          lnameRef.current.value &&
          number &&
          email
        ) {
          if (response.data.Status === "0") {
            // console.log(response.data);

            NotifyMessageNoReload(response.data.msg, "danger");

            setError(ProfileEditValidation(response.data.form_validation));
          }
          if (response.data.Status === "1") {
            // console.log(response.data);
            NotifyMessage(response.data.msg, "success", true);

            // navigate("/profile-edit");
            navigate(returnTo);
          }
        } else {
          // console.log(response.data);
          setError(ProfileEditValidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  // if (profLoading) {
  //   return <APIDataFetchLoader />;
  // }
  if (error) {
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "My Profile", pagelink: "profile" },
            { name: "Profile-Edit" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            <div className="row">
              <div className="col-lg-4">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content py-4">
                      <div className="profileimageBox">
                        <div className="profilebox">
                          {ProfileuserData.image !== "" ? (
                            <img
                              src={`${ProfileuserData.base_url}${ProfileuserData.image}`}
                              alt="avatar"
                              className="thumb"
                            />
                          ) : (
                            <img
                              src="images/blankUser.png"
                              alt="avatar"
                              className="thumb"
                            />
                          )}
                        </div>
                      </div>
                      <form
                        onSubmit={handleSubmit}
                        encType="multipart/form-data"
                        className="was-validated"
                      >
                        <div className="row">
                          <div className="form-group col-lg-12 col-md-12 mb-4">
                            <label>
                              Number <span className="text-danger">*</span>
                              {/* <span className="text-danger mx-3 emailverifytitle">
                                (Not Varified
                              </span> */}
                              {/* <span className="text-dark emailverifytitle verifynow">
                                Verify Now)
                              </span> */}
                              {/* <VarifyEmailBtn
                                updatetype="1" //number ke liye 1 or email ke liye 2
                                verifystatus="1" // verify ke liye 1 update ke liye 0
                                value={ProfileuserData?.number || ""}
                              /> */}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={number}
                              onChange={(e) => setNumber(e.target.value)}
                              readOnly
                            />
                          </div>

                          <div className="form-group col-lg-12 col-md-12 mb-2">
                            <label>
                              Email ID <span className="text-danger">*</span>
                              <span className="text-danger mx-3 emailverifytitle">
                                (
                                {/* <span className="text-dark emailverifytitle verifynow">
                                Verify Now)
                              </span> */}
                                {/* ============******For Email Verify*****=========== */}
                                <VarifyEmailBtn
                                  updatetype="2" //number ke liye 1 or email ke liye 2
                                  verifystatus="1" // verify ke liye 1 update ke liye 0
                                  value={email}
                                />
                                {/* ============******For Email Update*****=========== */}
                                <VarifyEmailBtn
                                  updatetype="2" //number ke liye 1 or email ke liye 2
                                  verifystatus="0" // verify ke liye 1 update ke liye 0
                                  value=""
                                />
                                )
                              </span>
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                            {error.email && (
                              <span className="text-danger">
                                * {error.email}
                              </span>
                            )}
                          </div>

                          {/* <div className="form-group col-lg-12 col-md-12 text-center mt-3">
                            <button
                              className="AllsiteButton mt-2"
                              type="submit"
                              name="submit"
                            >
                              SUBMIT
                            </button>
                          </div> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="ls-widget">
                  <div className="tabs-box">
                    <div className="widget-content py-4">
                      <form
                        onSubmit={handleSubmit}
                        encType="multipart/form-data"
                        className="was-validated"
                      >
                        <div className="row">
                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              First Name<span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              ref={fnameRef}
                              defaultValue={ProfileuserData?.firstname || ""}
                              required
                            />
                            {error.firstname && (
                              <span className="text-danger">
                                * {error.firstname}
                              </span>
                            )}
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              ref={lnameRef}
                              defaultValue={ProfileuserData?.lastname || ""}
                              required
                            />
                            {error.lastname && (
                              <span className="text-danger">
                                * {error.lastname}
                              </span>
                            )}
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Number <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={number}
                              onChange={(e) => setNumber(e.target.value)}
                              readOnly
                            />
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>
                              Email ID <span className="text-danger">*</span>
                              {/* <span className="text-danger mx-3 emailverifytitle">
                                (Not Varified
                              </span> */}
                              {/* <span className="text-dark emailverifytitle verifynow">
                                Verify Now)
                              </span> */}
                              {/* <VarifyEmailBtn /> */}
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                            {error.email && (
                              <span className="text-danger">
                                * {error.email}
                              </span>
                            )}
                          </div>
                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>Profile Image</label>
                            <div
                              className="input-group"
                              style={{ marginTop: "4px" }}
                            >
                              <input
                                className="form-control"
                                type="file"
                                accept=".png,.jpg,.jpeg"
                                ref={profileImageRef}
                              />
                              {ProfileuserData.image && (
                                <Link
                                  to={`${ProfileuserData.base_url}${ProfileuserData.image}`}
                                  data-fancybox
                                  data-caption="User Profile Image"
                                >
                                  <img
                                    src={`${ProfileuserData.base_url}${ProfileuserData.image}`}
                                    style={{
                                      width: "36px !important",
                                      height: "36px",
                                      marginleft: "10px !important",
                                      padding: "0px !important",
                                    }}
                                    alt="profileImg"
                                  />
                                </Link>
                              )}

                              <input
                                type="hidden"
                                ref={profileimagehiddenRef}
                                defaultValue={ProfileuserData?.image || ""}
                              />
                            </div>
                          </div>

                          <div className="form-group col-lg-6 col-md-12 mb-2">
                            <label>Banner Image</label>
                            <div
                              className="input-group"
                              style={{ marginTop: "4px" }}
                            >
                              <input
                                className="form-control"
                                type="file"
                                accept=".png,.jpg,.jpeg"
                                ref={bannerImageRef}
                              />
                              {ProfileuserData.banner && (
                                <Link
                                  to={`${ProfileuserData.base_url}${ProfileuserData.banner}`}
                                  data-fancybox
                                  data-caption="User Profile Banner"
                                >
                                  <img
                                    src={`${ProfileuserData.base_url}${ProfileuserData.banner}`}
                                    style={{
                                      width: "36px !important",
                                      height: "36px",
                                      marginleft: "10px !important",
                                      padding: "0px !important",
                                    }}
                                    alt="bannerimg"
                                  />
                                </Link>
                              )}

                              <input
                                type="hidden"
                                ref={bannerimagehiddenRef}
                                defaultValue={ProfileuserData?.banner || ""}
                              />
                            </div>
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              State<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={selectedState}
                              onChange={(e) => setSelectedState(e.target.value)}
                              required
                            >
                              <option value="">Select State</option>
                              {states.map((state, index) => (
                                <option value={state.id} key={index}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              City<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={selectedcity}
                              onChange={(e) => setSelectedcity(e.target.value)}
                              disabled={!cities.length}
                              required
                            >
                              <option value="">Select City</option>
                              {cities.map((city, index) => (
                                <option value={city.id} key={index}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              Country<span className="text-danger">*</span>
                            </label>
                            <select
                              className="chosen-select form-control"
                              value={selectCountry}
                              onChange={(e) => setselectCountry(e.target.value)}
                              required
                            >
                              <option value="">Select Country</option>
                              <option value="101">India</option>
                            </select>
                          </div>
                          <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
                            <label className="form-label">
                              Pincode<span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              name="pincode"
                              onChange={handlepincode}
                              onKeyPress={handleKeyPress}
                              value={pincode}
                              maxLength={6}
                              inputMode="text"
                              placeholder=""
                              required
                            />
                          </div>

                          <div className="form-group col-lg-12 col-md-12 ">
                            <label>
                              Address<span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows="2"
                              ref={addressRef}
                              defaultValue={ProfileuserData?.address || ""}
                              required
                            />
                          </div>

                          <div className="form-group col-lg-12 col-md-12 text-center mt-3">
                            <button
                              className="AllsiteButton mt-2"
                              type="submit"
                              name="submit"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
